
const remainingTime = ([days, hours, minutes, seconds]) => {
    return /*html*/`
                    <div class="remaining-time__time">
                            <p class="remaining-time__time__count" >
                                <span class="remaining-time__time__count__counter remaining-time__time__count--days">${days}</span>
                                <span class="remaining-time__time__count__text">DÍAS</span>
                            </p >
                            <p class="remaining-time__time__count">
                                <span class="remaining-time__time__count__counter remaining-time__time__count--hours">${hours}</span>
                                <span class="remaining-time__time__count__text">HORAS</span>
                            </p>
                            <p class="remaining-time__time__count">
                                <span class="remaining-time__time__count__counter remaining-time__time__count--minutes">${minutes}</span>
                                <span class="remaining-time__time__count__text">MIN</span>
                            </p>
                            <p class="remaining-time__time__count">
                                <span class="remaining-time__time__count__counter remaining-time__time__count--seconds">${seconds}</span>
                                <span class="remaining-time__time__count__text">SEG</span>
                            </p>
                        </div>`
}

module.exports = {
    remainingTime: remainingTime,
}



// WEBPACK FOOTER //
// ./Statics/scripts/paywall/views/remainingTime.js